var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEasyTransit = function SvgEasyTransit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#easy-transit_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.338,
    d: "M25.04 14.588c.658-.354 2.576-1.107 2.693-3.526.1-2.063-.312-3.93 1.36-3.933s1.643 1.197 1.646 2.558l.005 2.72 3.87-.104c.557-.052 1.902-.014 2.03.976.193 1.494-2.307 1.19-2.661 1.292.304.151 2.853-.548 2.856 1.136.002.858-.9 1.075-1.734 1.122.992.089 2.171.453 1.55 1.68-.177.348-1.042.482-1.7.533 2.595.094 2.137 2.44-1.53 2.276-3.996-.18-7.505.003-7.992-.359-.61-.452-.38-.172-.383-1.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.337 14.7c.658-.353 2.576-1.106 2.693-3.526.1-2.062-.312-3.93 1.36-3.933s1.643 1.197 1.646 2.558l.005 2.721 3.87-.105c.557-.052 1.902-.014 2.03.976.193 1.495-2.307 1.191-2.661 1.293.304.15 2.853-.549 2.856 1.136.002.858-.9 1.074-1.734 1.122.992.088 2.171.453 1.55 1.68-.177.347-1.042.48-1.7.532 2.594.095 2.137 2.44-1.53 2.276-3.996-.179-7.505.004-7.992-.358-.61-.453-.381-.173-.383-1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#easy-transit_svg__b)",
    fillOpacity: 0.05,
    d: "M24.337 14.7c.658-.353 2.576-1.106 2.693-3.526.1-2.062-.312-3.93 1.36-3.933s1.643 1.197 1.646 2.558l.005 2.721 3.87-.105c.557-.052 1.902-.014 2.03.976.193 1.495-2.307 1.191-2.661 1.293.304.15 2.853-.549 2.856 1.136.002.858-.9 1.074-1.734 1.122.992.088 2.171.453 1.55 1.68-.177.347-1.042.48-1.7.532 2.594.095 2.137 2.44-1.53 2.276-3.996-.179-7.505.004-7.992-.358-.61-.453-.381-.173-.383-1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.507,
    d: "M24.337 14.7c.658-.353 2.576-1.106 2.693-3.526.1-2.062-.312-3.93 1.36-3.933s1.643 1.197 1.646 2.558l.005 2.721 3.87-.105c.557-.052 1.902-.014 2.03.976.193 1.495-2.307 1.191-2.661 1.293.304.15 2.853-.549 2.856 1.136.002.858-.9 1.074-1.734 1.122.992.088 2.171.453 1.55 1.68-.177.347-1.042.48-1.7.532 2.594.095 2.137 2.44-1.53 2.276-3.996-.179-7.505.004-7.992-.358-.61-.453-.381-.173-.383-1.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m25.669 31.25-.343.308a1.46 1.46 0 0 1-1.522.27v.508a2.37 2.37 0 0 1-2.368 2.368l-.677-.339-1.352-3.72-3.214-2.22-4.059 3.403v.508a2.37 2.37 0 0 1-2.367 2.368c-1.061-7.17-3.355-21.751-3.214-22.325.051-.206.306-.57.642-.967 1.104-1.3 2.768-1.814 4.467-1.962l2.264-.197a23.3 23.3 0 0 1 5.859.23l.129.021 2.537.508a3.6 3.6 0 0 1 2.868 3.073l1.022 7.92v8.736a2.03 2.03 0 0 1-.672 1.508Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#easy-transit_svg__c)",
    fillOpacity: 0.4,
    d: "m25.669 31.25-.343.308a1.46 1.46 0 0 1-1.522.27v.508a2.37 2.37 0 0 1-2.368 2.368l-.677-.339-1.352-3.72-3.214-2.22-4.059 3.403v.508a2.37 2.37 0 0 1-2.367 2.368c-1.061-7.17-3.355-21.751-3.214-22.325.051-.206.306-.57.642-.967 1.104-1.3 2.768-1.814 4.467-1.962l2.264-.197a23.3 23.3 0 0 1 5.859.23l.129.021 2.537.508a3.6 3.6 0 0 1 2.868 3.073l1.022 7.92v8.736a2.03 2.03 0 0 1-.672 1.508Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.507,
    d: "M8.258 11.196a29.3 29.3 0 0 1 14.175 0 2.31 2.31 0 0 1 1.734 1.988l.903 8.268v9.571a.89.89 0 0 1-.89.891H6.51a.89.89 0 0 1-.889-.89v-9.58l.902-8.26a2.31 2.31 0 0 1 1.735-1.988Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.057 14.378A1.35 1.35 0 0 1 9.26 13.09l1.88-.208 2.987-.297a.34.34 0 0 1 .372.336v8.754a.34.34 0 0 1-.343.338l-5.726-.087a.677.677 0 0 1-.666-.705l.293-6.844Zm14.582 0a1.35 1.35 0 0 0-1.204-1.287l-1.88-.208-2.987-.297a.34.34 0 0 0-.372.336v8.754c0 .189.155.341.343.338l5.727-.087a.676.676 0 0 0 .665-.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.406 31.66h3.72v1.184a1.86 1.86 0 0 1-3.72 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.706,
    height: 4.397,
    x: 19.914,
    y: 29.8,
    fill: "#fff",
    rx: 1.353
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.57 31.66h3.721v1.184a1.86 1.86 0 0 1-3.72 0z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.706,
    height: 4.397,
    x: 8.078,
    y: 29.8,
    fill: "#fff",
    rx: 1.353
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.044,
    height: 3.044,
    x: 7.734,
    y: 26.755,
    fill: "#040404",
    rx: 1.522
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.044,
    height: 3.044,
    x: 19.914,
    y: 26.755,
    fill: "#040404",
    rx: 1.522
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-transit_svg__b",
    x1: 28.104,
    x2: 25.165,
    y1: 16.11,
    y2: 16.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "easy-transit_svg__c",
    x1: 29.047,
    x2: -16.278,
    y1: 16.946,
    y2: -0.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "easy-transit_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgEasyTransit;